.Footnotes {
  padding-block: var(--base-size-80);
  display: flex;
  flex-direction: column;
  gap: var(--base-size-12);
}

.Footnotes--variant-citations {
  margin: 0;
  padding-inline-start: var(--base-size-16);
  font-family: var(--brand-body-fontFamily);
  font-weight: var(--brand-text-weight-100);
  font-size: var(--brand-text-size-100);
  line-height: var(--brand-text-lineHeight-100);
  letter-spacing: var(--brand-text-letterSpacing-100);
  color: var(--brand-color-text-muted);
}

.Footnotes--variant-citations .FootnotesItem {
  padding-inline-start: var(--base-size-12);
}

.FootnotesItem {
  scroll-margin-top: 80px;
}

.FootnotesItem__citationIcon {
  transform: scaleY(-1);
  margin-inline-start: var(--base-size-4);
}

.FootnotesItem__citationText {
  display: inline;
  gap: var(--base-size-4);
}
